import React, { useContext, useState, useEffect } from "react"

import ReactDOM from "react-dom"

import { NewTeeupPageContext } from "@contexts/NewTeeupPageContext"
import { TEEUP_IMAGES } from "@config/teeupImages"

import { TeeupPageContext } from "../../contexts/TeeupPageContext"
import TeeupSettings from "../../pages/TeeUpPage/TeeUpPageLeftSection/TeeupSettings"
import DropDown from "../TeeUpsOverview/DropDown"

import { GoBack } from "./molecules"

// The detail-header cover must never be blank/grey (parity with the inbox card). Stable bundled
// default per teeup, same resolution as TeeUpPhoto.
const asCoverUrl = img => (img && img.default) || img
const defaultCoverFor = seed => {
  const s = String(seed ?? "")
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return asCoverUrl(TEEUP_IMAGES[h % TEEUP_IMAGES.length])
}
import {
  Wrapper,
  Line,
  Title,
  RightSide,
  DropdownWrapper,
  SettingsWrapper,
  SettignsIcon,
} from "./teeupOverviewHeaderStyles"

export const TeeupOverviewHeader = () => {
  const { teeup, isTeeupLoading, isSettings, setIsSettings } =
    useContext(NewTeeupPageContext)
  const { isTeeUpSettingsOpen, setIsTeeUpSettingsOpen } =
    useContext(TeeupPageContext)

  // Resolve the cover: preload teeup.photo so a null/404 cover falls back to a bundled default
  // instead of the grey banner (the "shows in inbox, blank in detail" case for recovered/lost
  // covers). The styled Wrapper already quotes the URL, so spaces are fine.
  const coverFallback = defaultCoverFor(teeup?.id || teeup?.name)
  const [coverPhoto, setCoverPhoto] = useState(teeup?.photo || coverFallback)
  useEffect(() => {
    const src = teeup?.photo
    if (!src) {
      setCoverPhoto(coverFallback)
      return
    }
    const probe = new Image()
    probe.onload = () => setCoverPhoto(src)
    probe.onerror = () => setCoverPhoto(coverFallback)
    probe.src = src
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teeup?.photo])

  return (
    <>
      <Wrapper $photo={coverPhoto}>
        {/* Top row: back arrow left; state chip + gear grouped top-right (iPhone parity --
            teeupHeaderActions groups the status chip immediately left of the settings button).
            Title is less important than the stage/settings row and now renders below, gaining
            visual primacy on its own line instead of a chip floating above it. */}
        <Line>
          <GoBack name={teeup.name} compact />

          <RightSide>
            <DropdownWrapper data-testid="teeup-detail-state-chip">
              <DropDown
                isHigh
                teeUp={teeup}
                title={teeup.name}
                imgUrl={teeup.photo}
              />
            </DropdownWrapper>

            <SettingsWrapper
              data-testid="teeup-settings-gear"
              $isDisabled={isTeeupLoading}
              onClick={() => setIsSettings(!isSettings)}>
              <SettignsIcon name="settings-3" color="var(--white)" />
            </SettingsWrapper>
          </RightSide>
        </Line>

        <Title data-testid="teeup-detail-title">{teeup.name}</Title>
      </Wrapper>

      {isTeeUpSettingsOpen &&
        ReactDOM.createPortal(
          <TeeupSettings close={() => setIsTeeUpSettingsOpen(false)} />,
          document.querySelector("#modal-root")
        )}
    </>
  )
}
